import { render, staticRenderFns } from "./Ingredient.vue?vue&type=template&id=13624ec8&scoped=true"
import script from "./Ingredient.vue?vue&type=script&lang=js"
export * from "./Ingredient.vue?vue&type=script&lang=js"
import style0 from "./Ingredient.vue?vue&type=style&index=0&id=13624ec8&prod&lang=css"
import style1 from "./Ingredient.vue?vue&type=style&index=1&id=13624ec8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13624ec8",
  null
  
)

export default component.exports